"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFailed = void 0;
const getEnabledQuestions_1 = __importDefault(require("./getEnabledQuestions"));
const getSelectedOptionsForAnswer_1 = __importDefault(require("./getSelectedOptionsForAnswer"));
const isFailed = (form, questionNode
// eslint-disable-next-line max-params
) => {
    if (!questionNode)
        questionNode = form.questionTree;
    const enabled = (0, getEnabledQuestions_1.default)(questionNode, z => { var _a; return !((_a = form.answers[z.nodeId]) === null || _a === void 0 ? void 0 : _a.notApplicable); });
    return enabled.some(node => {
        const q = form.questions[node.nodeId];
        const a = form.answers[node.nodeId];
        return (q && (0, getSelectedOptionsForAnswer_1.default)(q.type, form.rules[q.questionId], a).some(z => z.fail));
    });
};
exports.isFailed = isFailed;
exports.default = exports.isFailed;
